module.exports = __webpack_public_path__ + "static/img/slide3.1ecb3ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/slide3.jpg
// module id = LnN3
// module chunks = 1